export type FieldValue = unknown;
export type FieldCondition = unknown;

// TODO: each '{Component}Shape' type here should be defined in the corresponding component file

export type BaseFieldShape = {
  condition?: FieldCondition;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
} & Record<string, any>;

export type NestedFieldsDescriptor = {
  fields: FieldShape[];
};

export type MultiNumericFieldShape = {
  type: 'MultiNumericField';
} & NestedFieldsDescriptor;

export type ListItemFieldShape = {
  type: 'ListItem';
} & NestedFieldsDescriptor;

export type TabsFieldShape = {
  type: 'Tabs';
  tabs: TabShape[];
};

export type TabShape = BaseFieldShape & NestedFieldsDescriptor;

export type FormFieldsShape = {
  type: 'FormFields';
} & NestedFieldsDescriptor;

export type HiddenFieldShape = {
  type: 'HiddenField';
} & ValueFieldShape;

export type HtmlBlockShape = {
  type: 'HtmlBlock';
  html: string;
};

export type ValueFieldShape = {
  name: string;
  defaultValue?: FieldValue;
  forceValue?: FieldValue;
};

export type FieldShape = BaseFieldShape &
  (MultiNumericFieldShape | ListItemFieldShape | TabsFieldShape | TabShape | FormFieldsShape | HiddenFieldShape | ValueFieldShape | HtmlBlockShape);

export type FieldType = Extract<FieldShape, { type: string }>['type'];

export const isHtmlBlock = (f: FieldShape): f is HtmlBlockShape => f.type === 'HtmlBlock';
